import { AssignmentModel, CaseTypeEnum } from 'api/model';
import { useSupplierGetSupplierByCompany } from 'api/supplier/supplier';
import { useEffect } from 'react';
import { AssignmentField } from '../DetailedCaseFormProvider/types';

export interface NewAssignmentOverrides {
  firstPossibleStartTime?: Date;
  lastPossibleEndTime?: Date;
  isUsersFirstAssignmentOfDay?: boolean;
  isUsersLastAssignmentOfDay?: boolean;
}

// hard coded until we get more request on this type of feature
const allowedSupplierIds = [
  2, // Camboza
];

interface Props {
  assignment: AssignmentModel;
  currentCaseType: CaseTypeEnum;
  companyId?: number;
  onChange: (
    assignmentId: number,
    field: AssignmentField,
    value: string
  ) => void;
}

const useSetSendSmsToUser = ({ assignment, companyId, onChange }: Props) => {
  const getSupplierCall = useSupplierGetSupplierByCompany(
    {
      companyId,
    },
    {
      query: {
        enabled: !!companyId,
      },
    }
  );

  useEffect(() => {
    // if the assignment is new and sendCustomerStatusSMSOnAssigned is true, set the field to true
    if (assignment.assignmentID === -1) {
      // new assignment
      onChange(
        assignment.assignmentID,
        AssignmentField.sendCustomerUpdateMessages,
        allowedSupplierIds.includes(getSupplierCall.data?.id ?? -1)
          ? 'true'
          : 'false'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignment.assignmentID, getSupplierCall.data?.id]);
};

export default useSetSendSmsToUser;
